import merge from 'deepmerge';

function isHexColorCode(code) {
    return /^#([A-Fa-f0-9]{3}){1,2}$/.test(code);
}
var overwriteMerge = function (destinationArray, sourceArray, options) { return sourceArray; };
function mergeObjects(objA, objB) {
    return merge(objA, objB, { arrayMerge: overwriteMerge });
}

var ARCheckbox = {
render: function(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{class:[
    'ar-checkbox',
    _vm.color
  ],style:({
    flexDirection: _vm.align === 'left' ? null : 'row-reverse',
    cursor: _vm.disabled ? 'not-allowed' : 'pointer',
  }),attrs:{"ar-widget-id":"ar-checkbox","ar-widget-meta":_vm.arWidgetMeta || _vm.computedArWidgetMeta,"name":"ar-checkbox"},on:{"click":_vm.handleCheckboxTick}},[_c('div',{staticClass:"checkbox-section",style:({ flexDirection: _vm.align === 'left' ? 'row-reverse' : null })},[(_vm.comment)?_c('i',{staticClass:"comment",style:({
        marginLeft: _vm.align === 'left' ? '8px' : null,
        marginRight: _vm.align === 'right' ? '8px' : null,
      })},[_vm._v("\n      "+_vm._s(_vm.comment)+"\n    ")]):_vm._e(),_vm._v(" "),(_vm.type === 'tick' || _vm.type === 'round-tick')?_c('div',{class:[
        'tickbox',
        _vm.type === 'round-tick' && 'round' ],style:(_vm.tickBoxStyle)},[(_vm.isSemi && !_vm.isTicked)?_c('ar-icon',{style:(_vm.semiIconStyle),attrs:{"width":_vm.type === 'tick' ? '11px' : '10px',"name":"minus"}}):_c('ar-icon',{style:(_vm.tickIconStyle),attrs:{"width":_vm.type === 'tick' ? '11px' : '10px',"name":"check"}})],1):(_vm.type === 'radio')?_c('div',{staticClass:"radio"},[_c('div',{class:[
          'radio-inner-circle' ],style:(_vm.radioInnerCircleStyle)})]):_vm._e()]),_vm._v(" "),(_vm.label || _vm.iconName)?_c('div',{staticClass:"label-section",style:({
      marginLeft: _vm.align === 'left' ? _vm.labelSectionMargin : null,
      marginRight: _vm.align === 'right' ? _vm.labelSectionMargin : null,
      cursor: _vm.disabled ? 'not-allowed' : 'pointer',
    })},[(_vm.iconName)?_c('ar-icon',_vm._b({staticClass:"icon",attrs:{"name":_vm.iconName}},'ar-icon',_vm.iconPropsDecorated,false)):_vm._e(),_vm._v(" "),(_vm.label)?_c('ar-text',_vm._b({},'ar-text',_vm.labelTypographyPropsDecorated,false)):_vm._e()],1):_vm._e()])},
staticRenderFns: [],
  name: 'Checkbox',
  props: {
    arWidgetMeta: String,
    type: {
      type: String,
      default: 'tick',
      validator: (val) => ['round-tick', 'tick', 'radio'].indexOf(val) > -1,
    },
    iconName: {
      type: String,
      default: null,
    },
    iconProps: {
      type: Object,
      default: () => ({}),
    },
    label: {
      type: String,
      default: null,
    },
    labelTypographyProps: {
      type: Object,
      default: () => ({}),
    },
    comment: {
      type: String,
      default: null,
    },
    align: {
      type: String,
      default: 'left',
      validator: (val) => ['left', 'right'].indexOf(val) > -1,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    color: {
      type: String,
      default: 'purple',
      validator: (value) => {
        return ['purple', 'red'].indexOf(value) > -1 || isHexColorCode(value);
      },
    },
    disableUntick: {
      type: Boolean,
      default: false,
    },
    isSemi: {
      type: Boolean,
      default: false,
    },
    // Don't set type for it, it will break our logic for 'tickedValue'
    value: {
      default: false,
    },
    /**
     * Don't set type for 'tickedValue', we want it to be very flexible, if you did set any tickedValue that means
     * you really want that value, if you didn't set it, we put 'true' for you.
     * p.s: If type is Boolean, some tickedValue like '', undefined will be set to 'true', which is not we want.
     */
    tickedValue: {
      default: true,
    },
  },

  data() {
    return {
      isTicked: this.value === this.tickedValue,
      realValue: this.value,
    };
  },

  computed: {
    computedArWidgetMeta() {
      return [
        `checked=${this.isTicked};`,
        `label=${this.label};`
      ].join('');
    },
    isCustomColor() {
      return isHexColorCode(this.color);
    },
    baseColor() {
      if (this.color === 'purple') { return this.$arStyle.color.purple500; }
      else if (this.color === 'red') { return this.$arStyle.color.red500; }
      else if (this.isCustomColor) { return this.color; }
      else { return this.$arStyle.color.purple500; }
    },
    labelSectionMargin() {
      return this.iconName ? '20px' : '10px';
    },
    labelTypographyPropsDecorated() {
      return mergeObjects({
        size: 'xs',
        text: this.label,
        allowHtml: true,
        style: {
          cursor: this.disabled ? 'not-allowed' : 'pointer',
          opacity: this.disabled ? '0.26' : '1',
        },
      }, this.labelTypographyProps);
    },
    iconPropsDecorated() {
      const iconProps = {
        ...this.iconProps,
      };
      if (!this.iconProps.height && !this.iconProps.width) {
        iconProps.width = '16px';
        iconProps.height = '16px';
      }
      if (!iconProps.style) {
        iconProps.style = {};
      }
      iconProps.style.align === 'left' ? '10px' : null;
      iconProps.style.opacity = this.disabled ? '0.26' : '1';
      return iconProps;
    },
    radioInnerCircleStyle() {
      let backgroundColor;
      if (!this.isTicked) {
        backgroundColor = 'white';
      } else {
        if (this.disabled) {
          backgroundColor = this.$arStyle.color.skyBlueGrey600;
        } else {
          backgroundColor = this.baseColor;
        }
      }
      return {
        background: backgroundColor,
      };
    },
    tickBoxStyle() {//blueGrey500
      let borderColor;
      let backgroundColor;
      if (this.disabled) {
        borderColor = this.$arStyle.color.skyBlueGrey600;
        if (this.label || this.iconName) {
          backgroundColor = 'white';
        } else {
          backgroundColor = '#f5f5f6';
        }
      } else {
        borderColor = (this.isSemi || this.isTicked) ? this.baseColor : this.$arStyle.color.skyBlueGrey600;
        backgroundColor = this.isTicked ? this.baseColor : 'white';
      }

      return {
        border: `1px solid ${borderColor}`,
        background: backgroundColor,
      };
    },
    semiIconStyle() {
      if (!this.isTicked || !this.disabled) {
        return { color: this.baseColor };
      } else {
        return { color: 'none' };
      }
    },
    tickIconStyle() {
      if (this.disabled) {
        if (this.label || this.iconName) {
          return {
            color: this.isTicked ? this.$arStyle.color.skyBlueGrey600 : 'white',
          };
        } else {
          return {
            color: this.isTicked ? this.$arStyle.color.blueGrey500 : '#f5f5f6',
          };
        }
      } else {
        return {
          color: this.isTicked ? 'white' : 'white',
        };
      }
    },
  },

  watch: {
    value(val) {
      this.updateRealValue(val); // This enables us to use ar-checkbox even without v-model, important
    },
  },

  methods: {
    updateRealValue(val) {
      this.realValue = val;
      this.isTicked = this.realValue === this.tickedValue;
    },
    checkIfTicked() {
      return this.isTicked;
    },
    // Parent component can call this function with value, if not, it will work like toggle.
    toggle(tick) {
      if (tick === true || tick === false) {
        this.updateRealValue(tick ? this.tickedValue : false);
      } else {
        if (this.disabled) {
          return;
        }
        // Don't change if it's single select mode and it's already selected
        if (this.disableUntick && this.realValue === this.tickedValue) {
          return;
        }
        this.updateRealValue(this.realValue === this.tickedValue ? false : this.tickedValue);
      }

      this.$emit('input', this.realValue);
      // If you want other event to do things beside @input
      this.$emit('change', this.realValue);

      return this.realValue;
    },
    handleCheckboxTick() {
      this.toggle();
    },
  },
};

export default ARCheckbox;
